import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { WebProxyService } from '@shared/services/webproxy/webproxy.service'; // Techdebt
import { AuthB2CService } from 'common-web-core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private appSettingsService: AppSettingsService,
    private authB2cService: AuthB2CService,
    private webProxyService: WebProxyService
  ) { }

  async canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    if (await this.authB2cService.isUserLoggedIn()) {
      await this.webProxyService.signInToProxyAsync(
        this.appSettingsService.configuration.webProxySettings.webProyUri,
        this.appSettingsService.configuration.webProxySettings
          .authenticationEndPoint
      );
      return true;
    }
    sessionStorage.clear();
    this.authB2cService.login();
    return false;
  }
}
